
import React from 'react';
import Header from './components/Header';
import SkillMap from './components/SkillMap';
import SeniorVsJunior from './components/SeniorVsJunior';
import AICareerCoach from './components/AICareerCoach';
import HiringManagerInsights from './components/HiringManagerInsights';

const App: React.FC = () => {
  return (
    <div className="min-h-screen selection:bg-orange-500/30 selection:text-orange-200">
      {/* Background decoration */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-orange-500/10 blur-[120px] rounded-full"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-blue-500/5 blur-[120px] rounded-full"></div>
      </div>

      <Header />
      
      <main>
        <SkillMap />
        <SeniorVsJunior />
        <AICareerCoach />
        <HiringManagerInsights />
      </main>

      <footer className="py-20 px-6 border-t border-slate-800 text-center text-slate-500 text-sm">
        <div className="max-w-7xl mx-auto">
          <p className="mb-4">Designed for AWS Engineers who want to build systems, not just close tickets.</p>
          <p>© {new Date().getFullYear()} Architect Ascent. No HR fluff was used in the creation of this site.</p>
        </div>
      </footer>
    </div>
  );
};

export default App;
